import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.log');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-log',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.log/view.scss */
.glass-card {
  background-color: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(16px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  border-radius: 1rem;
  padding: 1.5rem;
  transition: all 0.2s;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.glass-card:hover {
  box-shadow: 0 30px 60px -12px rgba(0, 0, 0, 0.35), 0 10px 20px -5px rgba(0, 0, 0, 0.1);
  transform: scale(1.02);
}

.animate-gradient {
  background-size: 200% 200%;
  animation: gradientMove 2s ease-in-out infinite alternate;
}

@keyframes gradientMove {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}`],
})
export class PageAdminLogComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public q: string = '';
    public typingTimer: any = null;

    public logPairs: any[] = [];
    public page: number = 1;
    public lastpage: number = 1;
    public isExpanded: { [threadId: string]: boolean } = {};
    public pageSetStart: number = 1;
    public pageNumbers: number[] = [];
    public loading: boolean = false;
    private pageCache: Map<string, any> = new Map();

    public async ngOnInit() {
        await this.load();
    }

    public async load() {
        const cacheKey = `${this.page}_${this.q.trim()}`;
        if (this.pageCache.has(cacheKey)) {
            const cached = this.pageCache.get(cacheKey);
            this.logPairs = cached.logs;
            this.lastpage = cached.lastpage;
            this.updatePageNumbers();
            await this.service.render();
            this.prefetchNextPage();
            return;
        }

        this.loading = true;
        await this.service.render();
        const params: any = { page: this.page };
        if (this.q && this.q.trim()) params.q = this.q.trim();

        const { code, data } = await wiz.call('load_log_pairs', params);
        if (code === 200) {
            this.logPairs = data.logs || [];
            this.lastpage = data.lastpage || 1;
            this.pageCache.set(cacheKey, { logs: this.logPairs, lastpage: this.lastpage });

            const neededSetStart = Math.floor((this.page - 1) / 10) * 10 + 1;
            if (this.pageSetStart !== neededSetStart) {
                this.pageSetStart = neededSetStart;
            }
            this.updatePageNumbers();
        }
        this.loading = false;
        await this.service.render();
        this.prefetchNextPage();
    }

    private async prefetchNextPage() {
        if (this.page >= this.lastpage) return;
        const nextPage = this.page + 1;
        const cacheKey = `${nextPage}_${this.q.trim()}`;
        if (this.pageCache.has(cacheKey)) return;

        const params: any = { page: nextPage };
        if (this.q && this.q.trim()) params.q = this.q.trim();
        const { code, data } = await wiz.call('load_log_pairs', params);
        if (code === 200) {
            this.pageCache.set(cacheKey, { logs: data.logs || [], lastpage: data.lastpage || 1 });
        }
    }

    public async onSubmitSearch() {
        this.pageCache.clear();
        this.page = 1;
        this.pageSetStart = 1;
        await this.load();
    }

    public async onTyping() {
        if (this.typingTimer) clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(async () => {
            this.pageCache.clear();
            this.page = 1;
            this.pageSetStart = 1;
            await this.load();
        }, 400);
    }

    public clearSearch() {
        this.pageCache.clear();
        this.q = '';
        this.page = 1;
        this.pageSetStart = 1;
        this.load();
    }

    public expandContent(threadId: string) { this.isExpanded[threadId] = true; }
    public collapseContent(threadId: string) { this.isExpanded[threadId] = false; }

    public async goToPage(p: number) {
        if (p < 1 || p > this.lastpage) return;
        this.page = p;

        const neededSetStart = Math.floor((this.page - 1) / 10) * 10 + 1;
        if (this.pageSetStart !== neededSetStart) {
            this.pageSetStart = neededSetStart;
        }

        await this.load();
    }

    public async firstPage() {
        await this.goToPage(1);
    }

    public async lastPage() {
        await this.goToPage(this.lastpage);
    }

    public async prevSet() {
        let p = this.page - 10;
        if (p < 1) p = 1;
        await this.goToPage(p);
    }

    public async nextSet() {
        let p = this.page + 10;
        if (p > this.lastpage) p = this.lastpage;
        await this.goToPage(p);
    }

    public updatePageNumbers() {
        const end = Math.min(this.pageSetStart + 9, this.lastpage);
        this.pageNumbers = [];
        for (let i = this.pageSetStart; i <= end; i++) {
            this.pageNumbers.push(i);
        }
    }

    public async expandContent(threadId: string) {
        this.isExpanded[threadId] = true;
        await this.service.render();
    }

    public async collapseContent(threadId: string) {
        this.isExpanded[threadId] = false;
        await this.service.render();
    }

    public async trackByThread(_: number, item: any) {
        return item.thread_id;
    }
}

export default PageAdminLogComponent;